module.exports = __webpack_public_path__ + "static/media/option-plus.e5793fe0.svg";